<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="12">
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-modal.modal-prevent-closing
          variant="outline-primary"

          @click="modalClick"
        >
          ایجاد پروژه
        </b-button>
      </b-col>

    </b-row>

    <b-row
      v-if="projects.length"
      class="match-height"
    >
      <b-col
        v-for="project in projects"
        :key="project.id"
        lg="4"
      >
        <card-analytic-support-tracker
          :project="project"
          @update-project="updateProject"
        />
      </b-col>

    </b-row>

    <b-alert
      v-else
      variant="primary"
      show
      class="text-center"
    >
      <div class="alert-body">
        <span>شما هیچ پروژه ای ندارید</span>
      </div>
    </b-alert>

    <!-- modal -->
    <b-modal
      ref="submitProject"
      v-model="showProjectModal"
      :title="updateId ? `ویرایش ${name}` : 'ثبت پروژه جدید'"
      :ok-title="okTitle"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <validation-observer
        #default="handleSubmit"
        ref="refFormObserver"
      >
        <b-form
          ref="form"
          @submit.stop.prevent="handleSubmit"
        >
          <validation-provider
            #default="validationContext"
            name="عنوان"
            rules="required"
          >
            <b-form-group
              label="عنوان"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="name"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="عنوان وظیفه"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BAlert,
  BButton,
  BFormGroup,
  BFormInput,
  BModal,
  VBModal,
  BForm,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import {
  ref, computed, onMounted,
} from '@vue/composition-api'

import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import CompositionsApiComponents from '@/views/CompositionsApiComponents'
import axios from '@/libs/axios'
import { required } from '@core/utils/validations/validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import CardAnalyticSupportTracker from './project.vue'

export default {
  components: {
    BFormInvalidFeedback,
    ValidationProvider,
    BRow,
    BCol,
    BAlert,
    BButton,
    BFormGroup,
    BFormInput,
    BModal,
    CardAnalyticSupportTracker,
    BForm,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
  setup() {
    const projects = ref([])
    const name = ref(null)
    const updateId = ref(null)
    const nameState = ref(null)
    const submitProject = ref()
    const showProjectModal = ref(false)
    const onProgress = ref(false)

    const {
      getValidationState,

    } = formValidation(name)

    const {
      showToast,
    } = CompositionsApiComponents()

    const okTitle = computed(() => (onProgress.value ? 'در حال ارسال ...' : (updateId.value ? 'ویرایش' : 'جدید')))

    const projectsList = () => {
      axios.get('projects')
        .then(({ data }) => {
          projects.value = data
        })
        .catch(({ error }) => {
          showToast(error.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            variant: 'danger',
          })
        })
    }

    const modalClick = () => {
      showProjectModal.value = !showProjectModal.value
    }

    const resetModal = () => {
      name.value = ''
      nameState.value = null
      updateId.value = null
    }

    const handleOk = bvModalEvt => {
      bvModalEvt.preventDefault()

      if (updateId.value) {
        handleUpdate()
      } else {
        handleSubmit()
      }
    }

    const handleSubmit = () => {
      if (name.value) {
        onProgress.value = true
        axios.post('/projects', { name: name.value })
          .then(({ data }) => {
            projects.value.unshift(data)
            showProjectModal.value = false
          })
          .catch(({ error }) => {
            showToast(error.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
              title: 'حطا',
              variant: 'danger',
            })
          })
          .finally(() => onProgress.value = false)
      } else {

      }
    }
    const handleUpdate = () => {
      if (name.value) {
        onProgress.value = true
        axios.put(`/projects/${updateId.value}`, { name: name.value })
          .then(({ data }) => {
            if (data.status) {
              projects.value = projects.value.map(obj => {
                if (obj.id === data.project.id) {
                  return data.project
                }
                return obj
              })
              showProjectModal.value = false
            } else {
              showToast(data.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
                title: 'حطا',
                variant: 'danger',
              })
            }
          })
          .catch(({ error }) => {
            showToast(error.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
              title: 'حطا',
              variant: 'danger',
            })
          })
          .finally(() => onProgress.value = false)
      } else {

      }
    }
    const updateProject = projectData => {
      name.value = projectData.name
      updateId.value = projectData.id
      showProjectModal.value = true
      // if (name.value) {
      //
      //   axios.post('/projects', {name: name.value})
      //       .then(({data}) => {
      //         projects.value.unshift(data)
      //         showProjectModal.value = false;
      //       })
      //       .catch(({error}) => {
      //         showToast(error.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
      //           title: 'حطا',
      //           variant: 'danger'
      //         })
      //       })
      //
      // } else {
      //   return;
      // }
    }

    const checkFormValidity = () => true

    onMounted(() => {
      projectsList()
    })

    return {
      required,
      projects,
      showToast,
      name,
      updateId,
      nameState,
      submitProject,
      showProjectModal,
      onProgress,
      // methods
      projectsList,
      resetModal,
      handleOk,
      checkFormValidity,
      modalClick,
      getValidationState,
      updateProject,
      okTitle,
    }
  },
}
</script>

<style lang="scss">
//@import '@core/scss/vue/libs/chart-apex.scss';
</style>
